module.exports = __webpack_public_path__ + "img/question_mark.df2f9009.svg";